/**
 * Карточка сотрудника одной страницей из блоков (Чат 4, правка №15, доработка 5 — Света 04.11). [Claude] 2026-11-04
 * Каждый сам настраивает у себя: порядок блоков, скрыть / показать, свернуть, одна или две колонки,
 * в какой колонке блок. Хранится за пользователем: /v1/ui-preferences/employee_card.
 */
export const CARD_BLOCKS = [
    { id: "overview", label: "Обзор", title: "Данные сотрудника", side: false },
    { id: "contacts", label: "Контакты", title: "Контакты", side: true },
    { id: "resume", label: "Резюме", title: "Резюме", side: false },
    { id: "hiring", label: "Найм", title: "Найм", side: true },
    { id: "adaptation", label: "Адаптация", title: "Адаптация", side: false },
    { id: "assets", label: "Техника", title: "Техника и аккаунты", side: true },
    { id: "documents", label: "Документы", title: "Документы", side: false },
    { id: "photos", label: "Фото", title: "Фото", side: true },
    { id: "family", label: "Семья", title: "Семья", side: false },
    { id: "gifts", label: "Подарки", title: "Подарки", side: true },
];

const IDS = CARD_BLOCKS.map((b) => b.id);
const onlyKnown = (list) => [...new Set((Array.isArray(list) ? list : []).filter((id) => IDS.includes(id)))];

export const DEFAULT_CARD_PREFS = { order: [], hidden: [], collapsed: [], side: null, columns: 2 };

/** Full settings: unknown ids dropped, new blocks appended in the default order. */
export function normalizeCardPrefs(raw) {
    const value = raw && typeof raw === "object" ? raw : {};
    const known = onlyKnown(value.order);
    const order = [...known, ...IDS.filter((id) => !known.includes(id))];
    const side = Array.isArray(value.side) ? onlyKnown(value.side) : CARD_BLOCKS.filter((b) => b.side).map((b) => b.id);
    return {
        order,
        hidden: onlyKnown(value.hidden),
        collapsed: onlyKnown(value.collapsed),
        side,
        columns: value.columns === 1 ? 1 : 2,
    };
}

/** Blocks to show, split into columns: { main: [...], side: [...] } (one column → all in main). */
export function cardColumns(prefs) {
    const p = normalizeCardPrefs(prefs);
    const visible = p.order.filter((id) => !p.hidden.includes(id)).map((id) => CARD_BLOCKS.find((b) => b.id === id));
    if (p.columns === 1) return { main: visible, side: [] };
    return { main: visible.filter((b) => !p.side.includes(b.id)), side: visible.filter((b) => p.side.includes(b.id)) };
}

export function moveBlock(prefs, id, delta) {
    const p = normalizeCardPrefs(prefs);
    const order = [...p.order];
    const i = order.indexOf(id);
    const j = i + delta;
    if (i < 0 || j < 0 || j >= order.length) return p;
    [order[i], order[j]] = [order[j], order[i]];
    return { ...p, order };
}

export function toggleIn(prefs, listName, id) {
    const p = normalizeCardPrefs(prefs);
    const list = p[listName] || [];
    return { ...p, [listName]: list.includes(id) ? list.filter((x) => x !== id) : [...list, id] };
}
